import React from 'react';
import { connect } from 'react-redux';

import CartImport from '../components/cart/CartImport';


const CartImportPage = ({
  cartItems, cartOrderBy, cartLoaded, companyTag,
}) => (
  <main>
    <CartImport
      cartItems={cartItems}
      cartOrderBy={cartOrderBy}
      cartLoaded={cartLoaded}
      companyTag={companyTag}
    />
  </main>
);

const mapStateToProps = state => ({
  cartItems: state.cart.items,
  cartOrderBy: state.cart.orderBy,
  cartLoaded: state.cart.loaded,
  companyTag: state.settings.companyTag,
});

export default connect(mapStateToProps)(CartImportPage);
